module.exports = __webpack_public_path__ + "static/media/unlimitedGamesPlayed_1000000.df6da59b.png";